import { createFileRoute, redirect } from "@tanstack/react-router";

// /settings has no content of its own — bounce to the first settings tab.
export const Route = createFileRoute("/_authenticated/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/billing" });
  },
});
